import Vue from 'vue';
import Rollbar from 'vue-rollbar';

Vue.use(Rollbar, {
  accessToken: process.env.MIX_ROLLBAR_TOKEN,
  captureUncaught: false,
  captureUnhandledRejections: false,
  enabled: process.env.MIX_ROLLBAR_ENABLE,
  environment: process.env.MIX_APP_ENVIRONMENT,
  payload: {
    client: {
         javascript: {
            code_version: process.env.MIX_APP_VERSION,
            source_map_enabled: true,
            guess_uncaught_frames: true
         }
    }
}
});
